(function () {
  'use strict';

  angular.module('sempraWebapp').factory('loyaltyCampaignEnum', loyaltyCampaignEnumFactory);

  /** @ngInject */
  function loyaltyCampaignEnumFactory () {
    return Object.freeze({
      FINISHED : 'FINISHED',
      RUNNING : 'RUNNING',
      UPCOMING : 'UPCOMING',
      DEPRECATED : 'DEPRECATED'
    });
  }
})();
